import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTAFinal() {
  const { t } = useTranslation('charny');

  return (
    <section className="py-14 md:py-20 bg-[#C77D3F]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3 md:mb-4">
          {t('cta_h2')}
        </h2>
        <p className="text-sm md:text-base text-white/85 mb-8 md:mb-10 max-w-xl mx-auto">
          {t('cta_subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/soumission-gratuite"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white text-[#C77D3F] font-semibold rounded-md hover:bg-white/90 transition-colors whitespace-nowrap text-base"
          >
            {t('cta_button')}
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>

          <a
            href="tel:+14184769950"
            aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
            title="Cliquez pour appeler"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border-2 border-white text-white font-semibold rounded-md hover:bg-white/10 transition-colors whitespace-nowrap text-base"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-line" />
            </span>
            {t('cta_phone')}
          </a>
        </div>
      </div>
    </section>
  );
}